import Providers from "@/routes/_main/-providers";
import { Outlet, createFileRoute } from "@tanstack/react-router";

// Pathless layout for all main app pages
export const Route = createFileRoute("/_main")({
  component: MainLayout,
});

function MainLayout() {
  return (
    <Providers>
      <Outlet />
    </Providers>
  );
}
